
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/429",
      function () {
        return require("private-next-pages/429.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/429"])
      });
    }
  